import { createContext, useContext } from "react";

/**
 * Contexte de la coquille applicative.
 *
 * `pending` = nombre de scans encore en vol vers le backend. Les pages qui
 * synchronisent (InventairePage) le publient via `setPending` ; la coquille
 * l'affiche dans le bandeau. C'est la seule information dont le bandeau a
 * besoin : hors ligne + scans en attente = risque de perte, l'opérateur doit
 * le voir sans quitter son écran de scan.
 */
export const AppShellContext = createContext({
  theme: "dark",
  toggleTheme: () => {},
  online: true,
  pending: 0,
  setPending: () => {},
});

export const useAppShell = () => useContext(AppShellContext);

export const THEME_KEY = "sip_stock_theme";

export const loadTheme = () => {
  try {
    return localStorage.getItem(THEME_KEY) === "light" ? "light" : "dark";
  } catch {
    return "dark";
  }
};

/** Retour haptique sur scan validé (ignoré silencieusement si non supporté). */
export const feedback = () => {
  if (typeof navigator !== "undefined" && navigator.vibrate) navigator.vibrate(60);
};
